import type * as Types from 'app/types/graphql';

import { ShopShopifySelectFragmentDoc } from '../fragments/shopShopify.generated';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { appFetcher } from '~/api/utils/gatewayClient';
export type ShopShopifyQueryVariables = Types.Exact<{ [key: string]: never }>;

export type ShopShopifyQueryResponse = {
  shopShopify?: Types.Maybe<Pick<Types.ShopShopify, 'currency' | 'primary_locale' | 'domain'>>;
};

export const ShopShopifyDocument = `
    query ShopShopify {
  shopShopify {
    ...ShopShopifySelect
  }
}
    ${ShopShopifySelectFragmentDoc}`;

export const useShopShopifyQuery = <TData = ShopShopifyQueryResponse, TError = unknown>(
  variables?: ShopShopifyQueryVariables,
  options?: UseQueryOptions<ShopShopifyQueryResponse, TError, TData>,
) => {
  return useQuery<ShopShopifyQueryResponse, TError, TData>(
    variables === undefined ? ['ShopShopify'] : ['ShopShopify', variables],
    appFetcher<ShopShopifyQueryResponse, ShopShopifyQueryVariables>(ShopShopifyDocument, variables),
    options,
  );
};

useShopShopifyQuery.getKey = (variables?: ShopShopifyQueryVariables) =>
  variables === undefined ? ['ShopShopify'] : ['ShopShopify', variables];
